import React, {useState, useContext} from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles"
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {getCode} from "../../api/db";
import Typography from "@mui/material/Typography";
import {red} from '@mui/material/colors';
import {styled} from '@mui/material/styles';

const ColorButton = styled(Button)(({theme}) => ({
    fontSize: 32,
    backgroundColor: red[500],
    '&:hover': {
        backgroundColor: red[700],
    },
}));


export const ReferralSuccessMsg = ({form}) => {
        const registerEyespy = async () => {
            const code = await getCode();

            if(window.parent){
                return window.parent.location.href = `https://e3.eyespy360.com/p/autosign_promo.pl?email=${encodeURI(form.email)}&referrer=photographer&code=${code}`
            }

            window.location.href = `https://e3.eyespy360.com/p/autosign_promo.pl?email=${encodeURI(form.email)}&referrer=photographer&code=${code}`
        }

        return (<Container maxWidth={'md'}><Box display={"flex"}
                                                flexDirection={"column"}
                                                style={{textAling: 'center'}}
                                                alignItems={"center"}>
            <Box><Typography variant={'h3'}>Thank you for your referral.</Typography></Box><br/>
            <Box><Typography variant={'h6'}>An invitation has been sent to the referred person.
                Should you have any questions in the interim, please don’t hesitate to get in touch either by email, telephone, online chat or our Apple SMS Chat, all details of which can be found below.</Typography></Box><br/>
        </Box></Container>)
    }
;